<a [smNavigate]="logoLink">
  <span class="icon" *ngIf="svgLogo" [smSvgIcon]="svgLogo"></span>
  <img [alt]="logoName" *ngIf="notSVGLogo" [src]="notSVGLogo" loading="lazy">
  <span class="logo-name">{{logoName}}</span>
</a>
